import { gql } from '@apollo/client';

import {
  BillingPlanKind,
  BillingPlanTier,
  UI__IsUserProbablyBillingContactQuery,
  UI__IsUserProbablyBillingContactQueryVariables,
  UI__IsUserProbablyBillingContactQuery_user,
  UI__IsUserProbablyBillingContactQuery_user_memberships_account,
} from 'src/lib/graphqlTypes/types';

export const isUserProbablyBillingContactQuery = gql<
  UI__IsUserProbablyBillingContactQuery,
  UI__IsUserProbablyBillingContactQueryVariables
>`
  query UI__IsUserProbablyBillingContactQuery($userId: ID!) {
    user(id: $userId) {
      id
      email
      memberships {
        account {
          id
          name
          currentPlan {
            id
            tier
            kind
          }
          billingContactEmail
          memberships {
            account {
              id
            }
            user {
              id
            }
          }
        }
        user {
          id
        }
      }
    }
  }
`;

export const isUserPossiblyBillingContactForOrg = (
  user: UI__IsUserProbablyBillingContactQuery_user,
  org: UI__IsUserProbablyBillingContactQuery_user_memberships_account,
) => {
  if (
    !(
      // this will include orgs on a Team trial, so we will block users from
      // deleting themselves if they are the main contact for an org on a trial
      (
        (org.currentPlan?.tier === BillingPlanTier.ENTERPRISE &&
          org.currentPlan?.kind !== BillingPlanKind.ENTERPRISE_TRIAL) ||
        org.currentPlan?.tier === BillingPlanTier.TEAM ||
        org.currentPlan?.kind === BillingPlanKind.SERVERLESS_PAID
      )
    )
  )
    return false;

  return (
    // user's email matches billing contact email
    (org.billingContactEmail && org.billingContactEmail === user.email) ||
    // user is only member in organization
    (org.memberships?.length === 1 &&
      org.memberships.every((member) => member.user.id === user.id))
  );
};
